var React = require('react');

function SnellIconClock (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .snell-icon-clock {\n        fill: #ff5032;\n      }\n    ")),React.createElement("path",{"id":"Path_1274","data-name":"Path 1274","className":"snell-icon-clock","d":"M3.3,3.3A9.974,9.974,0,0,1,10.987,0a9.974,9.974,0,0,1,7.691,3.3,9.974,9.974,0,0,1,3.3,7.691,9.974,9.974,0,0,1-3.3,7.691,9.974,9.974,0,0,1-7.691,3.3,9.974,9.974,0,0,1-7.691-3.3A10.965,10.965,0,0,1,0,10.987,9.974,9.974,0,0,1,3.3,3.3ZM15.931,15.931l1.282-1.282-4.578-4.578L10.987,2.747H9.156v8.24a1.662,1.662,0,0,0,.549,1.282.639.639,0,0,0,.366.183Z","transform":"translate(-9242.626 2492.964)","key":1})]);
}

SnellIconClock.defaultProps = {"viewBox":"-9242.627 2492.964 21.974 21.974"};

module.exports = SnellIconClock;

SnellIconClock.default = SnellIconClock;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js?name=SnellIconClock!./src/assets/images/icon_clock.svg
// module id = 945
// module chunks = 1